import { Injectable } from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {LadeanzeigeService} from '../prozesse/ladeanzeige.service';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';

@Injectable()
export class LoadingScreenInterceptor implements HttpInterceptor {
  private activeRequests = 0;
  private excludedRoutes = ['/profile', '/faq', 'menu', 'einstellungen', 'rechtliches']

  constructor(
    private ladeanzeigeService: LadeanzeigeService,
    private router: Router
  ) {
    // Optional: Bei Navigation neue Ladeanzeige starten
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && !this.excludedRoutes.some(eintrag => eintrag.includes(event.url))) {
        this.ladeanzeigeService.ladeAnzeige.next(true);
      }else{
        this.ladeanzeigeService.ladeAnzeige.next(false);
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.shouldIgnore(request)) {
      if (this.activeRequests === 0) {
        this.ladeanzeigeService.ladeAnzeige.next(true);
      }
      this.activeRequests++;
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!this.shouldIgnore(request)) {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.ladeanzeigeService.ladeAnzeige.next(false);
          }
        }
      })
    );
  }

  // Optional: Anfragen ignorieren (z. B. Logging, Heartbeat)
  private shouldIgnore(request: HttpRequest<any>): boolean {
    return false; // z. B.: request.url.includes('/ping')
  }
}
